import { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { addDays, dayLabel, monthGridStart, todayCT } from "@/lib/calendar";

// Month calendar: only dates with an open start time for the chosen lesson are selectable.
export default function LessonDatePicker({ days, value, onPick }) {
  const avail = new Set(days);
  const [month, setMonth] = useState((value || days[0] || todayCT()).slice(0, 7));
  const start = monthGridStart(`${month}-01`);
  const grid = Array.from({ length: 42 }, (_, i) => addDays(start, i));
  const shift = (n) => setMonth(addDays(`${month}-15`, 30 * n).slice(0, 7));
  const today = todayCT();
  const canPrev = month > today.slice(0, 7);
  const canNext = days.some((d) => d.slice(0, 7) > month);
  return (
    <div data-testid="lesson-date-picker" className="mt-4 rounded-2xl border border-white/10 p-4 max-w-md">
      <div className="flex items-center justify-between">
        <button data-testid="lesson-month-prev" disabled={!canPrev} onClick={() => shift(-1)} className="rounded-full border border-white/15 p-2 disabled:opacity-30" aria-label="Previous month"><ChevronLeft size={16} /></button>
        <p data-testid="lesson-month-title" className="text-base font-extrabold">{dayLabel(`${month}-15`, { month: "long", year: "numeric" })}</p>
        <button data-testid="lesson-month-next" disabled={!canNext} onClick={() => shift(1)} className="rounded-full border border-white/15 p-2 disabled:opacity-30" aria-label="Next month"><ChevronRight size={16} /></button>
      </div>
      <div className="mt-3 grid grid-cols-7 gap-1 text-center">
        {["M", "T", "W", "T", "F", "S", "S"].map((x, i) => <span key={i} className="text-[11px] font-bold text-white/40">{x}</span>)}
        {grid.map((d) => {
          const ok = avail.has(d);
          const inMonth = d.slice(0, 7) === month;
          return (
            <button key={d} disabled={!ok} data-testid={`lesson-day-${d}`} onClick={() => onPick(d)}
              className={`aspect-square rounded-xl text-sm font-bold transition-colors ${!inMonth ? "invisible" : value === d ? "bg-white text-[#0B0F19]" : ok ? "border border-white/25 text-white hover:border-white" : "text-white/20 line-through cursor-not-allowed"}`}>
              {Number(d.slice(8))}
            </button>
          );
        })}
      </div>
      <p className="mt-3 text-xs font-medium text-white/45">Dates in white have open times. All times Central.</p>
    </div>
  );
}
